/**
 * Strip null/undefined/empty-string fields from a payload object before sending.
 * Preserves keys named "date". Set `recurse` to also clean nested objects.
 */
export function cleanup(obj: Record<string, unknown>, recurse?: boolean): void {
  for (const i in obj) {
    if (i === 'date') continue
    if (obj[i] == null || obj[i] === '') {
      delete obj[i]
    } else if (recurse && typeof obj[i] === 'object' && obj[i] !== null) {
      cleanup(obj[i] as Record<string, unknown>, recurse)
    }
  }
}
